import { Lead, LeadField } from '@/api/types/crm.types'

type uniqueNameFieldStatic =
  // | '_SELECT
  // | '_INDEX'
  '_DELETEBUTTON' | '_TAKEBUTTON' | '_MANAGERFIO' | '_STATUS'

export const getLeadField = (
  lead: Lead | undefined,
  uniqueName: uniqueNameFieldStatic | string,
): LeadField | undefined =>
  lead?.fields.find((field) => field.unique_name === uniqueName)

export const getLeadFieldValue = (
  lead: Lead | undefined,
  uniqueName: uniqueNameFieldStatic | string,
): string | undefined => getLeadField(lead, uniqueName)?.value
